import { Component, OnInit, OnDestroy } from "@angular/core";
import { Router } from "@angular/router";
import { StorageService } from "../../services/storage.service";
import { AuthService } from "../../services/auth.service";
import swal from "sweetalert2";

@Component({
    selector: "exchange",
    templateUrl: "./exchange.component.html",
    host: { class: "exchange-main" },
})
export class ExchangeComponent implements OnInit, OnDestroy {

    isProcessing: boolean = true;

    constructor(
        private router: Router,
        private authService: AuthService,
        private storageService: StorageService
    ) {
        const url = new URL(window.location.href);
        const code = url.searchParams.get("code");
        const state = url.searchParams.get("state");        

        this.authService.exchange(code, state)
            .then((result) => {                
                console.log(`[ExchangeComponent] Exchange successful. Re-directing to /portal`);                    
                this.router.navigate(["/portal"]);                
            })
            .catch((error) => {
                console.error(`[ExchangeComponent] Failed to exchange - ${JSON.stringify(error)}`);  
                swal("Login attempt failed", "Your login failed. Please try again.")
                    .then(() => {
                        authService.logout();
                    });
            });
    }

    ngOnInit() {}

    ngOnDestroy() {}
}
